import React from 'react';
import { Button, Divider, Form, Input, Select, Switch, message } from 'antd';
import { useUpdateNotificationsMutation } from '../../queries/me';
import { Card, CardHead } from '../../components';

const NOTIFY_OPTIONS = [
  { label: 'High priority & emergencies only', value: 'high_priority' },
  { label: 'Every captured request', value: 'all' },
  { label: 'Turn off alerts', value: 'off' }
];

const toForm = (n = {}) => ({
  notifyOn: n.notifyOn || 'high_priority',
  smsEnabled: !!n.sms?.enabled,
  smsNumbers: (n.sms?.numbers || []).join(', '),
  slackEnabled: !!n.slack?.enabled,
  slackWebhookUrl: n.slack?.webhookUrl || ''
});

const toPayload = (v) => ({
  notifyOn: v.notifyOn,
  sms: {
    enabled: v.smsEnabled,
    numbers: (v.smsNumbers || '')
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean)
  },
  slack: { enabled: v.slackEnabled, webhookUrl: v.slackWebhookUrl }
});

export default function AlertsCard({ notifications }) {
  const { mutate, isPending } = useUpdateNotificationsMutation();

  const save = (v) =>
    mutate(toPayload(v), {
      onSuccess: () => message.success('Notification settings saved'),
      onError: (err) => message.error(err.response?.data?.message || 'Failed to save')
    });

  return (
    <Card aria-labelledby="alerts-title">
      <CardHead>
        <h2 id="alerts-title">Alerts</h2>
        <span>when your assistant captures a request</span>
      </CardHead>
      <Form layout="vertical" onFinish={save} initialValues={toForm(notifications)}>
        <Form.Item name="notifyOn" label="Notify me about">
          <Select options={NOTIFY_OPTIONS} />
        </Form.Item>

        <Divider orientation="left" plain>
          Text message (SMS)
        </Divider>
        <Form.Item name="smsEnabled" label="Enable SMS alerts" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item
          name="smsNumbers"
          label="Send to numbers"
          tooltip="Comma-separated, E.164 (e.g. +18175551234, +18175559876)"
        >
          <Input placeholder="+18175551234, +18175559876" />
        </Form.Item>

        <Divider orientation="left" plain>
          Slack
        </Divider>
        <Form.Item name="slackEnabled" label="Enable Slack alerts" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item
          name="slackWebhookUrl"
          label="Incoming webhook URL"
          tooltip="Create one in Slack → Apps → Incoming Webhooks"
        >
          <Input placeholder="https://hooks.slack.com/services/..." />
        </Form.Item>

        <Button type="primary" htmlType="submit" loading={isPending}>
          Save alerts
        </Button>
      </Form>
    </Card>
  );
}
